import React from "react";
import PropTypes from "prop-types";

/**
 * Shared price display component for billing plans.
 * Handles missing plan, null (custom), 0 (free), undefined, and numeric prices.
 * Note: plan.price is in DOLLARS (decimal), unlike credit packages which use CENTS.
 */
// M6: Conditions ordered by semantic specificity to make null-vs-undefined explicit.
// 1. No plan → Free  2. null price → Custom  3. price 0 → Free  4. number → dollar  5. fallback
const PlanPrice = ({ plan, className }) => {
  // No plan at all → "Free" (matches CurrentPlanCard's name fallback of "Free")
  if (!plan) {
    return (
      <span className={`billing-price-free ${className || ""}`}>Free</span>
    );
  }

  const { price } = plan;

  // null = intentionally custom/enterprise pricing (admin sets price to null)
  if (price === null) {
    return (
      <span className={`billing-price-custom ${className || ""}`}>Custom</span>
    );
  }

  // 0 = free tier
  if (price === 0) {
    return (
      <span className={`billing-price-free ${className || ""}`}>Free</span>
    );
  }

  // Positive number = standard dollar amount
  if (typeof price === "number") {
    return (
      <>
        <span className={`billing-price-amount ${className || ""}`}>
          ${price}
        </span>
        <span className="billing-price-period">/month</span>
      </>
    );
  }

  // undefined or unexpected type → dash (deactivated/misconfigured plan)
  return (
    <span className={`billing-price-unknown ${className || ""}`}>&mdash;</span>
  );
};

PlanPrice.propTypes = {
  plan: PropTypes.shape({
    price: PropTypes.number,
  }),
  className: PropTypes.string,
};

export default PlanPrice;
